// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"155":"books","201":"entry","353":"contact","566":"resources","594":"about","949":"cart"}[chunkId] || chunkId) + "." + {"155":"9d121796","201":"896865d7","353":"d40dae1d","453":"a69d1111","566":"1d93319c","594":"072b5c4b","949":"932f8edf"}[chunkId] + ".chunk.js";
};